const state = {
  notifications: [],
  uniqueId: 0
}

const mutations = {
  REMOVE (state, notificationId) {
    var index = state.notifications.map(x => {
      return x.id;
    }).indexOf(notificationId);
    state.notifications.splice(index, 1);
  },
  ADD (state, notification) {
    notification.id = state.uniqueId++
    state.notifications.push(notification);
  }
}

const getters = {
  getNotifications: state => state.notifications
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
